import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { UserAppletContainerModel} from "../../../../../../models/aggregates/applet-store/user-applet-container.model";
import { ApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Pagination } from '../../shared/pagination.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';


// https://api.akaun.cloud/core2/platform/dm/login-tenant-links/tenant-admin-ep

@Injectable({
  providedIn: 'root'
})
export class TenantLoginLinksTenantAdminEpService extends BaseApiTemplateService<UserAppletContainerModel> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'login-tenant-links/tenant-admin-ep';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'login-tenant-links/tenant-admin-ep';
    this.httpClient = http;
  }

  getByTenantCode(tenantCode: string, pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<UserAppletContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path +'/'+ tenantCode +'/query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<UserAppletContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }

  // /core2/platform/dm/login-tenant-links/multiple-delete/{tenantCode}/tenant-admin-ep

  deleteMultiple(
    tenantCode: string,
    dto: any,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${Core2Config.PLATFORM_DOMAIN_URL_PREFIX}login-tenant-links/multiple-delete/${tenantCode}/tenant-admin-ep`;
    }

    return this.httpClient.post<ApiResponseModel<any>>(this.apiUrl, dto, this.getHttpHeader(visa));
  }

}
